// src/stores/ContentStore.ts - Updated với Strapi v5 documentId support
// ✅ GIỮ NGUYÊN TẤT CẢ FUNCTIONS KHÁC - CHỈ SỬA CÁC OPERATIONS DELETE/UPDATE

import { makeAutoObservable, runInAction, toJS } from "mobx";
import { RootStore } from "./index";
import { ID } from "@/types";
import { v4 as uuidv4 } from 'uuid';
import { setDate } from "date-fns";

// Mock data
const dummyNotifications = [
  {
    id: uuidv4(),
    title: "Thông báo mới",
    content: "Bạn có một thông báo mới từ hệ thống",
    isRead: false,
    type: "info",
		createdAt: new Date(),
  },
  {
    id: uuidv4(),
    title: "Tài liệu đã được duyệt",
    content: 'Tài liệu "Hướng dẫn sử dụng" đã được phê duyệt',
    isRead: true,
    type: "success",
		createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)
  },
	{
    id: uuidv4(),
    title: "Thông báo mới",
    content: "Bạn có một thông báo mới từ hệ thống",
    isRead: false,
    type: "info",
		createdAt: new Date(Date.now() - 29 * 24 * 60 * 60 * 1000)
  },
  {
    id: uuidv4(),
    title: "Tác phẩm đã được duyệt",
    content: 'Tác phẩm "Chùm nho xanh" đã được phê duyệt',
    isRead: true,
    type: "success",
		createdAt: new Date(Date.now() - 99 * 24 * 60 * 60 * 1000)
  },
];

class NotificationStore {
  rootStore: RootStore;

  isLoading: boolean = false;
  error: string | null = null;
  notifications: any[] = [];
  unreadNotificationCount: number = 0;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
  }

  setError(error: string | null) {
    this.error = error;
  }

  async fetchNotifications() {
    if (!this.rootStore.authStore.currentUser) return;

    runInAction(() => {
      this.isLoading = true;
      this.error = null;
    });

    const { id: userId } = this.rootStore.authStore.currentUser;

    try {
			// TODO CALL API fetchNotifications with userId
			
			if(import.meta.env.MODE === 'development' && userId) {
				this.notifications = dummyNotifications;
				this.unreadNotificationCount = this.notifications.filter(n => !n.isRead).length || 0;
			}
    } catch (error: any) {
      console.error("Error fetching user content:", error);
      runInAction(() => {
        this.error = "Get notification user error";
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

	async markNotificationAsRead(id: ID) {
		if (!id) return;

		runInAction(() => {
			this.isLoading = true;
			this.error = null;
		});

		try {
			const index = this.notifications.findIndex(n => n.id === id);

			if (index !== -1 && !this.notifications[index].isRead) {
				// 🔹 TEST local dummy data
				this.notifications[index].isRead = true;
				// TODO CALL API
			} else {
				throw new Error("Notification not found");
			}

			runInAction(() => {
				this.unreadNotificationCount = this.notifications.filter(n => !n.isRead).length || 0;
			});
		} catch (error: any) {
			console.error("Error marking notification as read:", error);
			runInAction(() => {
				this.error = "Error marking notification as read";
			});
		} finally {
			runInAction(() => {
				this.isLoading = false;
			});
		}
	};

	async markAllNotificationsAsRead() {
		runInAction(() => {
      this.isLoading = true;
      this.error = null;
    });
		try {
			// 🔹 TEST local dummy data
			this.notifications.forEach(n => {
				n.isRead = true;
			});
			// TODO CALL API UPDATE AND FETCH DATA
			runInAction(() => {
				this.unreadNotificationCount = this.notifications.filter(n => !n.isRead).length || 0;
      });
    } catch (error: any) {
      console.error("Error fetching user content:", error);
      runInAction(() => {
        this.error = "Get notification user error";
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
	};
}

export default NotificationStore;
